interface BrandLogoProps {
  className?: string;
}

export const VisaLogo = ({ className }: BrandLogoProps) => (
  <svg
    data-testid="smp-cardBrand-visa"
    width="34"
    height="12"
    viewBox="0 0 64 22"
    className={className}
  >
    <text
      x="0"
      y="17"
      fontFamily="inherit"
      fontWeight="700"
      fontStyle="italic"
      fontSize="18"
      fill="#1A1F71"
      letterSpacing="-0.5"
    >
      VISA
    </text>
  </svg>
);

export const MastercardLogo = ({ className }: BrandLogoProps) => (
  <svg
    data-testid="smp-cardBrand-mc"
    width="28"
    height="18"
    viewBox="0 0 40 26"
    className={className}
  >
    <circle cx="14" cy="13" r="10" fill="#EB001B" />
    <circle cx="26" cy="13" r="10" fill="#F79E1B" fillOpacity="0.92" />
  </svg>
);

export const AmexLogo = ({ className }: BrandLogoProps) => (
  <svg
    data-testid="smp-cardBrand-amex"
    width="32"
    height="14"
    viewBox="0 0 56 16"
    className={className}
  >
    <rect width="56" height="16" rx="1" fill="#1F72CD" />
    <text
      x="6"
      y="11.5"
      fontFamily="inherit"
      fontWeight="700"
      fontSize="8"
      fill="#fff"
      letterSpacing="0.5"
    >
      AMEX
    </text>
  </svg>
);

export const DiscoverLogo = ({ className }: BrandLogoProps) => (
  <svg
    data-testid="smp-cardBrand-discover"
    width="36"
    height="11"
    viewBox="0 0 70 14"
    className={className}
  >
    <text x="0" y="11" fontFamily="inherit" fontWeight="700" fontSize="10" fill="#231F20">
      DISC
    </text>
    <circle cx="58" cy="7" r="5" fill="#FF6000" />
  </svg>
);

export const PaypalLogo = ({ className }: BrandLogoProps) => (
  <svg
    data-testid="smp-cardBrand-paypal"
    width="58"
    height="16"
    viewBox="0 0 124 36"
    className={className}
  >
    <text
      x="0"
      y="26"
      fontFamily="inherit"
      fontWeight="700"
      fontStyle="italic"
      fontSize="22"
      fill="#003087"
    >
      Pay
    </text>
    <text
      x="44"
      y="26"
      fontFamily="inherit"
      fontWeight="700"
      fontStyle="italic"
      fontSize="22"
      fill="#009CDE"
    >
      Pal
    </text>
  </svg>
);

export const GenericCardLogo = ({ className }: BrandLogoProps) => (
  <svg
    data-testid="smp-cardBrand-generic"
    width="22"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    className={className}
  >
    <rect x="3" y="6" width="18" height="13" rx="2.5" />
    <path d="M3 10h18M7 15h3" />
  </svg>
);

export const resolveBrandLogo = (
  brand?: string | null,
): React.ComponentType<BrandLogoProps> => {
  const b = (brand || '').toLowerCase();
  if (b === 'visa') return VisaLogo;
  if (b === 'mastercard' || b === 'mc') return MastercardLogo;
  if (b === 'amex' || b === 'american_express') return AmexLogo;
  if (b === 'discover') return DiscoverLogo;
  if (b === 'paypal') return PaypalLogo;
  return GenericCardLogo;
};
